import getters from './getters';
import mutations from './mutations';

const state = {
  showRoom: {
    filtersHasChanged: false,
    filtersHasReseted: false,
    tabActive: '',
    filters: {
      campaignType: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'campaignType[eqs]=#values#'
      },
      carFuelType: {
        value: [],
        dataType: 'Array',
        query: 'car.fuelType[in]=#values#'
      },
      carBrand: {
        value: '',
        dataType: 'String',
        query: 'car.brand[eqs]=#value#'
      },
      carModel: {
        value: '',
        dataType: 'String',
        query: 'car.model[eqs]=#value#'
      },
      carBodyStyle: {
        value: [],
        dataType: 'Array',
        query: 'car.bodyStyle[in]=#values#'
      },
      quoteIdQuote: {
        value: '',
        dataType: 'String',
        query: 'quote.idQuote[like]=#value#'
      },
      quoteTimeLimit: {
        value: [],
        dataType: 'Array',
        query: 'quote.timeLimit[in]=#values#'
      },
      carCO2Emission: {
        value: [],
        dataType: 'Range',
        query: 'car.cO2Emission[gte]=#value1#&car.cO2Emission[lte]=#value2#'
      },
      quoteYearKms: {
        value: [],
        dataType: 'Array',
        query: 'quote.yearKms[in]=#values#'
      },
      quotePrice: {
        value: [],
        dataType: 'Range',
        query: 'quote.price[gte]=#value1#&quote.price[lte]=#value2#'
      },
      deliveryProvinceCode: {
        value: [],
        dataType: 'Array',
        query: 'deliveryProvinceCode[in]=#values#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
